export default "__VITE_ASSET__d25d7357__"